import { usePolicyCancellation } from "~/contexts/PolicyCancellationContext";

const usePolicyActive = () => {
	const { getPolicyCancellation } = usePolicyCancellation();
	return !!getPolicyCancellation()?.isPolicyCancellationActive;
};

export default usePolicyActive;
